/** Parse /cart/add.js body — errors may be JSON or an HTML document (avoid JSON.parse on DOCTYPE). */
async function parseShopifyCartAddResponse(response) {
	const text = await response.text();
	try {
		return JSON.parse(text);
	} catch {
		const snippet = text.slice(0, 120).trim();
		const looksLikeHtml =
			snippet.startsWith('<') || snippet.toUpperCase().includes('<!DOCTYPE');
		throw new Error(
			looksLikeHtml
				? 'The store could not complete that request. Please refresh the page and try again.'
				: 'Could not add this item to your cart.'
		);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	// Get data from the DOM element
	const productContainer = document.querySelector('.mainProduct');
	if (!productContainer) return;

	const sectionId = productContainer.dataset.sectionId;
	const productId = productContainer.dataset.productId;
	const productForm = document.getElementById('productForm');

	if (!productForm) return;

	const variantIdInput = document.getElementById('productVariantId');
	const quantityInput = document.getElementById('productQuantity');
	const addToCartButton = productForm.querySelector('.addToCartButton');

	// Get product variants from the data attribute (parsed JSON)
	let productVariants = [];
	try {
		productVariants = JSON.parse(
			productContainer.dataset.productVariants || '[]'
		);
	} catch (e) {
		console.error('Error parsing product variants:', e);
	}

	// Liquid's product.variants | json often has option1/2/3 but no reliable options[] array
	function variantOptionAt(variant, index) {
		if (!variant) return undefined;
		if (Array.isArray(variant.options) && variant.options[index] !== undefined) {
			return variant.options[index];
		}
		const key = 'option' + (index + 1);
		return variant[key];
	}

	function normalizeOptionValue(value) {
		return String(value == null ? '' : value).trim().toLowerCase();
	}

	function selectionsComplete(selectedOptions) {
		return selectedOptions.every(v => normalizeOptionValue(v) !== '');
	}

	// Mirrors the stable "Pick your style" resolver approach: resolve by option1/2/3 fallback
	// and match deterministic full selections.
	function findVariantByOptions(selectedOptions) {
		if (!selectionsComplete(selectedOptions)) return null;
		return productVariants.find(variant =>
			selectedOptions.every(
				(s, i) =>
					normalizeOptionValue(variantOptionAt(variant, i)) ===
					normalizeOptionValue(s)
			)
		);
	}

	// Function to update variant selection
	function updateVariant() {
		const selectedOptions = [];

		// Get selected values from dropdowns or buttons
		const variantGroups = document.querySelectorAll('.variantGroup');
		variantGroups.forEach(group => {
			const dropdown = group.querySelector('.variantSelect');
			if (dropdown) {
				selectedOptions.push(dropdown.value);
			} else {
				const activeButton = group.querySelector('.variantButton.active');
				if (activeButton) {
					selectedOptions.push(activeButton.getAttribute('data-value'));
				}
			}
		});

		// Find matching variant
		const matchedVariant = findVariantByOptions(selectedOptions);

		if (matchedVariant) {
			if (variantIdInput) {
				variantIdInput.value = String(matchedVariant.id);
			}

			// Update price display
			const priceElement = document.querySelector(
				`#price-${sectionId} .priceRegular`
			);
			if (priceElement && matchedVariant.price) {
				priceElement.textContent = formatMoney(matchedVariant.price);
			}

			// Update add to cart button state
			if (addToCartButton) {
				if (matchedVariant.available) {
					addToCartButton.disabled = false;
					addToCartButton.innerHTML = '~ Add to Cart ~';
				} else {
					addToCartButton.disabled = true;
					addToCartButton.innerHTML = '~ Sold Out ~';
				}
			}

			// Update quantity max if needed
			if (quantityInput) {
				if (
					matchedVariant.inventory_management &&
					matchedVariant.inventory_quantity > 0
				) {
					const maxQty = Math.min(matchedVariant.inventory_quantity, 99);
					quantityInput.max = maxQty;
					if (parseInt(quantityInput.value) > maxQty) {
						quantityInput.value = maxQty;
					}
				} else {
					quantityInput.max = 99;
				}
			}
		} else {
			if (variantIdInput) {
				variantIdInput.value = '';
			}
			if (addToCartButton) {
				addToCartButton.disabled = true;
				addToCartButton.innerHTML = '~ Unavailable ~';
			}
		}
	}

	// Format money helper function
	function formatMoney(cents) {
		if (!cents && cents !== 0) return '$0.00';

		// Try to get money format from data attribute if available
		const moneyFormat =
			document.querySelector('.mainProduct')?.dataset.moneyFormat ||
			'${{amount}}';
		const amount = cents / 100;

		return moneyFormat
			.replace('{{amount}}', amount.toFixed(2))
			.replace('{{amount_no_decimals}}', Math.floor(amount).toString());
	}

	// Handle variant buttons (button style)
	const variantButtons = document.querySelectorAll('.variantButton');
	variantButtons.forEach(button => {
		button.addEventListener('click', function (e) {
			e.preventDefault();
			const group = this.closest('.variantGroup');
			const buttons = group.querySelectorAll('.variantButton');

			// Update active state
			buttons.forEach(btn => btn.classList.remove('active'));
			this.classList.add('active');

			// Update variant
			updateVariant();
		});
	});

	// Handle variant dropdowns
	const variantSelects = document.querySelectorAll('.variantSelect');
	variantSelects.forEach(select => {
		select.addEventListener('change', function () {
			updateVariant();
		});
	});

	// Handle quantity buttons
	const decreaseBtn = document.querySelector('.quantityDecrease');
	const increaseBtn = document.querySelector('.quantityIncrease');

	if (decreaseBtn && increaseBtn && quantityInput) {
		decreaseBtn.addEventListener('click', function () {
			let currentValue = parseInt(quantityInput.value);
			const minValue = parseInt(quantityInput.min) || 1;
			if (currentValue > minValue) {
				quantityInput.value = currentValue - 1;
				quantityInput.dispatchEvent(new Event('change'));
			}
		});

		increaseBtn.addEventListener('click', function () {
			let currentValue = parseInt(quantityInput.value);
			const maxValue = parseInt(quantityInput.max) || 99;
			if (currentValue < maxValue) {
				quantityInput.value = currentValue + 1;
				quantityInput.dispatchEvent(new Event('change'));
			}
		});

		// Ensure quantity stays within bounds when manually entered
		quantityInput.addEventListener('change', function () {
			let value = parseInt(this.value);
			const min = parseInt(this.min) || 1;
			const max = parseInt(this.max) || 99;

			if (isNaN(value) || value < min) {
				this.value = min;
			} else if (value > max) {
				this.value = max;
			}
		});
	}

	// Handle form submission (Add to Cart)
	if (productForm) {
		productForm.addEventListener('submit', function (e) {
			e.preventDefault();

			// Disable button to prevent double submission
			if (addToCartButton) {
				addToCartButton.disabled = true;
				const originalButtonText = addToCartButton.innerHTML;
				addToCartButton.innerHTML = '~ Adding... ~';

				const chosenVariantId = variantIdInput
					? String(variantIdInput.value || '').trim()
					: '';
				if (!chosenVariantId) {
					addToCartButton.disabled = false;
					addToCartButton.innerHTML = originalButtonText;
					showNotification(
						'This combination is not available. Please choose different options.',
						'error'
					);
					return;
				}

				// Get form data
				const formData = new FormData(productForm);

				// Make AJAX request to add to cart
				fetch('/cart/add.js', {
					method: 'POST',
					body: formData,
					credentials: 'same-origin',
					headers: {
						Accept: 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
				})
					.then(async response => {
						const data = await parseShopifyCartAddResponse(response);
						if (!response.ok) {
							throw new Error(
								data.description ||
									data.message ||
									'Could not add this item to your cart.'
							);
						}
						return data;
					})
					.then(data => {
						// Success - update cart UI
						addToCartButton.innerHTML = '~ Added! ~';

						// Dispatch custom event for cart update
						document.dispatchEvent(
							new CustomEvent('cartUpdated', { detail: data })
						);

						if (window.cartManager && typeof window.cartManager.refreshCartData === 'function') {
							window.cartManager.refreshCartData();
						}

						// Show success message
						showNotification('Product added to cart!', 'success');

						// Reset button after delay
						setTimeout(() => {
							addToCartButton.disabled = false;
							addToCartButton.innerHTML = originalButtonText;
						}, 2000);
					})
					.catch(error => {
						console.error('Error adding to cart:', error);
						addToCartButton.disabled = false;
						addToCartButton.innerHTML = originalButtonText;
						showNotification(
							error.message ||
								'Error adding product to cart. Please try again.',
							'error'
						);
					});
			}
		});
	}

	// Helper function to show notifications
	function showNotification(message, type = 'success') {
		let notification = document.querySelector('.product-notification');

		if (!notification) {
			notification = document.createElement('div');
			notification.className = 'product-notification';
			document.body.appendChild(notification);
		}

		notification.textContent = message;
		notification.classList.add(type);
		notification.classList.add('show');

		setTimeout(() => {
			notification.classList.remove('show');
		}, 3000);
	}

	// Initialize variant selection if there are variants
	if (variantButtons.length > 0 || variantSelects.length > 0) {
		updateVariant();
	}

	// Add CSS for notifications dynamically if not present
	if (!document.querySelector('#product-notification-styles')) {
		const style = document.createElement('style');
		style.id = 'product-notification-styles';
		style.textContent = `
      .product-notification {
        position: fixed;
        bottom: 20px;
        right: 20px;
        padding: 12px 24px;
        border-radius: 25px;
        font-family: var(--font-primary, sans-serif);
        font-weight: 600;
        z-index: 9999;
        transform: translateX(400px);
        transition: transform 0.3s ease;
      }
      .product-notification.show {
        transform: translateX(0);
      }
      .product-notification.success {
        background: var(--color-mauve, #c47c7c);
        color: white;
      }
      .product-notification.error {
        background: #e74c3c;
        color: white;
      }
    `;
		document.head.appendChild(style);
	}
});

// Global function for image switching (if used)
window.switchImage = function (button, imageUrl) {
	const mainImage = document.querySelector('.galleryMainImage');
	if (mainImage) {
		mainImage.removeAttribute('width');
		mainImage.removeAttribute('height');
		mainImage.src = imageUrl;
	}

	const thumbnails = document.querySelectorAll('.thumbnailButton');
	thumbnails.forEach(btn => btn.classList.remove('active'));
	button.classList.add('active');
};
